/** One count above the staff roster. */
import type { LucideIcon } from 'lucide-react';

export default function StaffStatCard({
  label,
  value,
  icon: Icon,
  tone,
}: {
  label: string;
  value: string | number;
  icon: LucideIcon;
  /** Tailwind text colour for the icon — the one thing that differs per card. */
  tone: string;
}) {
  return (
    <div className="bg-white dark:bg-[#1a1f1c] rounded-lg p-4 border">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-stone-600 dark:text-stone-400">{label}</p>
          <p className="text-2xl font-bold text-bark-900 dark:text-[#e8ece9] mt-1">{value}</p>
        </div>
        <Icon className={tone} size={24} />
      </div>
    </div>
  );
}
